import clsx from "clsx";
import { VideoSidebar } from "common/src/gamePage/types";
import { useAttachStore } from "common/src/gamePage/attach-store";
import { _, _any } from "i18n";

interface SidebarMenuProps {
	isAnalysed: boolean;
	showEvents: boolean;
	showCoachingTools: boolean;
	sidebar: VideoSidebar | null;
	setSidebar: (sidebar: VideoSidebar) => void;
	setSidebarAndFilter: (sidebar: VideoSidebar) => void;
	eventCommentsPermission: boolean;
}

export function SidebarMenu({
	isAnalysed,
	showEvents,
	showCoachingTools,
	sidebar,
	setSidebar,
	setSidebarAndFilter,
	eventCommentsPermission,
}: SidebarMenuProps) {
	const { target: attachTarget } = useAttachStore();
	const isAttachMode = attachTarget !== null;

	return (
		<div className="sidebarMenu-container">
			<div
				className={clsx("menuItem", {
					selected: sidebar === VideoSidebar.TeamSheet,
				})}
				onClick={() => setSidebar(VideoSidebar.TeamSheet)}
			>
				<div className="item-icon">
					<span className="icon-new icon-users icon-20" />
				</div>
				<div className="item-text">{_("gamePage.label.teamSheet")}</div>
			</div>
			{isAnalysed && showEvents && (
				<div
					className={clsx("menuItem", {
						selected: sidebar === VideoSidebar.Timeline,
					})}
					onClick={() => setSidebar(VideoSidebar.Timeline)}
				>
					<div className="item-icon">
						<span className="icon-new icon-stopwatch icon-20" />
					</div>
					<div className="item-text">{_("gamePage.label.timeline")}</div>
				</div>
			)}
			<div
				className={clsx("menuItem eventList-menu-item", {
					selected: sidebar === VideoSidebar.EventList || sidebar === VideoSidebar.AttachMode,
				})}
				onClick={() => {
					if (isAttachMode) {
						setSidebar(VideoSidebar.AttachMode);
						return;
					}

					setSidebar(VideoSidebar.EventList);
				}}
			>
				<div className="item-icon">
					<span className="icon-new icon-video-list icon-20" />
				</div>
				<div className="item-text">{_("gamePage.label.eventList")}</div>
			</div>
			{eventCommentsPermission && isAttachMode === false && (
				<div
					className={clsx("menuItem", {
						selected: sidebar === VideoSidebar.EventsWithComments,
					})}
					onClick={() => setSidebarAndFilter(VideoSidebar.EventsWithComments)}
				>
					<div className="item-icon">
						<span className="icon-new icon-comment icon-20" />
					</div>
					<div className="item-text">{_any("gamePage.label.eventsWithComments")}</div>
				</div>
			)}
			{showCoachingTools && (
				<div
					className={clsx("menuItem eventList-menu-item", {
						selected: sidebar === VideoSidebar.CoachingTools || sidebar === VideoSidebar.TeamPlayerReviews,
					})}
					onClick={() => setSidebar(VideoSidebar.CoachingTools)}
				>
					<div className="item-icon">
						<span className="icon-new icon-whistle-blow icon-20" />
					</div>
					<div className="item-text">{_("gamePage.label.coachingTools")}</div>
				</div>
			)}
		</div>
	);
}
